import * as React from "react";
import { InsuranceInfo } from "../patient-portal/InsuranceInfo";
import sfetch from "../commons/utils/super-fetch";
import PhoneNumber from "../commons/components/PhoneNumber";
import { formatBirthDateAndAge } from "../commons/utils/text-rendering";
import LabelledDataForm from "../label/LabelledDataForm";

export default function InsuranceInformationItemsList({
  insuranceInfo,
  title,
}: {
  insuranceInfo: InsuranceInfo;
  title: string;
}) {
  const openInsuranceCard = async (fileUrl) => {
    const response = await sfetch(fileUrl, {
      method: "GET",
    });
    window.open(URL.createObjectURL(await response.blob()), "_blank");
  };

  return (
    <div className="insurance-info-items">
      <h3>{i18n[title]}</h3>
      <LabelledDataForm
        data={[
          {
            label: i18n["Form.Field.Title.FirstName"],
            value: insuranceInfo.firstName,
          },
          {
            label: i18n["Form.Field.Title.MiddleName"],
            value: insuranceInfo.middleName,
          },
          {
            label: i18n["Form.Field.Title.LastName"],
            value: insuranceInfo.lastName,
          },
          {
            label: i18n["Form.Field.Title.BirthDate"],
            value: formatBirthDateAndAge(insuranceInfo.birthDate),
          },
          {
            label: i18n["Form.Field.Title.SSN"],
            value: insuranceInfo.socialSecurityNumber,
          },
          {
            label: i18n["Form.Field.Title.Employer"],
            value: insuranceInfo.employer,
          },
          {
            label: i18n["Form.Field.Title.InsuranceId"],
            value: insuranceInfo.insuranceId,
          },
          {
            label: i18n["Form.Field.Title.EmployerId"],
            value: insuranceInfo.employerId,
          },
          {
            label: i18n["Form.Field.Title.CompanyName"],
            value: insuranceInfo.companyName,
          },
          {
            label: i18n["Form.Field.Title.State"],
            value: insuranceInfo.state,
          },
          {
            label: i18n["Form.Field.Title.CompanyPhone"],
            value: <PhoneNumber number={insuranceInfo.companyPhoneNumber} />,
          },
          {
            label: i18n["Form.Field.Title.CompanyGroupNumber"],
            value: insuranceInfo.companyGroupNumber,
          },
          {
            label: i18n["Form.Field.Title.InsuranceCard"],
            value: insuranceInfo.insuranceCardUrl && (
              <>
                {insuranceInfo.insuranceCardFileName} -&nbsp;
                <a
                  className={"link"}
                  onClick={() => openInsuranceCard(insuranceInfo.insuranceCardUrl)}
                >
                  {i18n["Page.Portal.InsuranceInformation.ViewFile.Title"]}
                </a>
              </>
            ),
          },
        ]}
      />
    </div>
  );
}
